import * as React from 'react';
import { SVGProps } from 'react';
const RulerAndPenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41.22 41"
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="m19.541 26.684 8.593 8.547c.71.705 1.86.705 2.57 0l4.718-4.693a1.8 1.8 0 0 0 0-2.556l-8.593-8.546M32.067 14.213l-5.153-5.125M21.675 14.312l-8.59-8.543a1.824 1.824 0 0 0-2.569 0L5.8 10.46a1.8 1.8 0 0 0 0 2.556l8.59 8.543" />
      <path d="m5.68 33.193 1.232-3.685c.168-.504.453-.964.831-1.34L30.558 5.478a1.722 1.722 0 0 1 2.428 0l2.724 2.71a1.7 1.7 0 0 1 0 2.415L12.892 33.297a3.453 3.453 0 0 1-1.34.825l-3.697 1.23c-1.342.446-2.621-.823-2.175-2.16Z" />
    </g>
  </svg>
);
export default RulerAndPenIcon;
